import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";

const get = function (params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: Array<{
      subscription_id: number;
      username: string;
    }>;
  }>("/payments", { params });
};

const post = function (data: { subscription_id: number; username: string }) {
  return api.post("/payments", data);
};

const id = function (ref_id: number) {
  return api.get(`payments/${ref_id}`);
};

export const payments = {
  id,
  post,
  get,
};
